const userMenu = {
  en: {
    abilities: "Abilities",
    open_menu: "Open user menu",
    options: "User Options",
    my_account: "My Account",
    team_members: "Team Members",
    profiles: "Profiles",
    system_log: "System Log",
    logout: "Logout"
  },
  pt: {
    abilities: "Habilidades",
    open_menu: "Abrir menu de usuário",
    options: "Opções do Usuário",
    my_account: "Minha Conta",
    team_members: "Membros da Equipe",
    profiles: "Perfis",
    system_log: "Log do Sistema",
    logout: "Sair"
  },
  es: {
    abilities: "Habilidades",
    open_menu: "Abrir el menú de usuario",
    options: "Opciones del Usuario",
    my_account: "Mi Cuenta",
    team_members: "Miembros del Equipo",
    profiles: "Perfiles",
    system_log: "Registro del Sistema",
    logout: "Cerrar la sesión"
  }
}

export default userMenu
